<template>
	<div>
		<b-modal
			:id="modalId"
			centered
			no-close-on-backdrop
			no-close-on-esc
			hide-header
			footer-class="border-top-0"
			>
			<section class="d-flex flex-column align-items-center">
				<div class="circle-ripple">
					<img class="fe fe-alert-circle text-success" src="../../../../assets/img/success.svg" style="font-size: 24px" />
				</div>
				<p class="mt-4 mb-0 title-text">Reward deleted</p>
				<p class="mt-2 mb-0 description-text">
					You have successfully deleted a reward.
				</p>
			</section>
			<template #modal-footer>
				<div class="btns">
					<button
						:disabled="loading"
						class="btn proceed btn-primary"
						@click="$emit('onAcceptEvent')"
						>
						{{ loading ? 'Processing...' : 'Dismiss' }}
					</button>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
export default {
  name: 'DeleteRewardSuccessModal',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalId: 'delete-reward-success-modal'
    }
  },
  emits: ['onAcceptEvent']
}
</script>

<style lang="scss" scoped>
$success-icon-bg: #D1FADF;

.hidden {
  display: none !important;
}
.title-text {
  color: #101828;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
}

.description-text {
  color: #667085;
  font-size: 14px;
  line-height: 20px;
}

.text-success {
  display: block;
  text-align: center;
  color: #D1FADF;
}

.btns {
  width: 100%;
  display: flex;
  gap: 20px;

  .btn {
    height: 44px;

    &.cancel {
      flex: 1;
      border: 1px solid#D0D5DD;
    }
    &.proceed {
      flex: 1;
    }
  }
}

.circle-ripple {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $success-icon-bg;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  animation: ripple 0.7s linear infinite;
}

@keyframes ripple {
  0% {
    box-shadow: 0 0 0 0 rgba($success-icon-bg, 0.3),
      0 0 0 1em rgba($success-icon-bg, 0);
  }
  100% {
    box-shadow: 0 0 0 1em rgba($success-icon-bg, 0.3),
      0 0 0 3em rgba($success-icon-bg, 0);
  }
}
</style>
